var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.024,
    height: 40.024,
    viewBox: "0 0 40.024 40.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147076",
    "data-name": "Rectangle 147076",
    width: 21.771,
    height: 21.771,
    transform: "translate(0 0)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187492",
    "data-name": "Group 187492",
    transform: "translate(-15 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37627",
    "data-name": "Path 37627",
    d: "M10.006,0H30.018A10.006,10.006,0,0,1,40.024,10.006V30.018A10.006,10.006,0,0,1,30.018,40.024H10.006A10.006,10.006,0,0,1,0,30.018V10.006A10.006,10.006,0,0,1,10.006,0Z",
    transform: "translate(15 16)",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_187417",
    "data-name": "Group 187417",
    transform: "translate(24 24.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185866",
    "data-name": "Group 185866",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17947",
    "data-name": "Path 17947",
    d: "M0,26.5a7.763,7.763,0,0,1,.215-.839A2.6,2.6,0,0,1,2.6,23.879c1.281-.088,2.572-.043,3.858-.056h.3c0-.094.01-.176.011-.257.006-.5-.015-.994.021-1.487a1.223,1.223,0,0,1,1.221-1.154c1.81-.017,3.621-.01,5.431-.012.12,0,.241,0,.36.014A1.255,1.255,0,0,1,14.944,22.1c.024.474.014.949.018,1.424,0,.092,0,.183,0,.307h.26c1.1,0,2.206,0,3.31,0a3.555,3.555,0,0,1,1.757.4,2.8,2.8,0,0,1,1.434,2.426c.009.12.009.241.009.361q0,4.773,0,9.546a3.368,3.368,0,0,1-.453,1.851,2.833,2.833,0,0,1-2.221,1.305,7.933,7.933,0,0,1-.868.031q-7.447,0-14.893,0a3.9,3.9,0,0,1-1.557-.261A2.721,2.721,0,0,1,.046,37.275c-.01-.061-.03-.12-.046-.18V26.5M10.843,38.855h7.6a4.773,4.773,0,0,0,.487-.014,1.843,1.843,0,0,0,1.746-1.224,3.329,3.329,0,0,0,.16-1.041c.012-3.189.007-6.379.006-9.568,0-.106,0-.213-.01-.319a1.864,1.864,0,0,0-1.494-1.869,3.475,3.475,0,0,0-.84-.091q-7.627-.008-15.255,0a3.985,3.985,0,0,0-.592.039A1.793,1.793,0,0,0,1.055,25.98,3.373,3.373,0,0,0,.9,27C.888,30.2.893,33.394.893,36.591c0,.106,0,.213.01.319a1.83,1.83,0,0,0,1.2,1.762,3.516,3.516,0,0,0,1.12.176c2.539.015,5.078.008,7.617.008M7.671,23.814h6.387c.005-.059.014-.114.014-.169,0-.439,0-.878,0-1.317s-.127-.549-.564-.55c-.749,0-1.5,0-2.247,0-1.032,0-2.063,0-3.095,0-.337,0-.486.121-.493.42-.012.53,0,1.061,0,1.615",
    transform: "translate(0 -19.443)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17951",
    "data-name": "Path 17951",
    d: "M106.494,123.056h2.161V124c0,.326,0,.652,0,.978,0,.4.168.567.568.568.629,0,1.258,0,1.9,0v2.176h-1.892c-.418,0-.572.155-.574.58,0,.553,0,1.105,0,1.658v.245h-2.168c0-.083-.01-.158-.01-.234,0-.553,0-1.105,0-1.658,0-.441-.15-.59-.584-.591h-1.882v-2.172h.221c.566,0,1.131,0,1.7,0,.376,0,.545-.168.548-.544,0-.574,0-1.148,0-1.722,0-.075.006-.151.01-.226",
    transform: "translate(-96.707 -114.408)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.25
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.0366aabe8cb69fb6a64ba20025548845.svg";
export { ForwardRef as ReactComponent };